import { useCookie } from 'nuxt/app';
import { defineStore } from 'pinia';


export const useMyCookieStore = defineStore({
  id: 'myCookieStore',
  state: () => ({
    modelPerformans: useCookie('performans').value === 'true', 
    modelHedefleme: useCookie('hedefleme').value === 'true', 
    modelIslevsel: useCookie('islevsel').value === 'true', 
    innerWidth: 961,
  }),
  getters: {
    getModelPerformans(state) {
      return state.modelPerformans;
    },
    getModelHedefleme(state) {
      return state.modelHedefleme;
    },
    getModelIslevsel(state) {
      return state.modelIslevsel;
    },
    getInnerWidth(state) {
      return state.innerWidth;
    },
  },
  actions: {
    // Çerezlere değer yazma
    updateInnerWidth(newValue: any) {
      this.innerWidth = newValue;
    },
    updateModelPerformans(newValue: boolean) {
      this.modelPerformans = newValue;
      useCookie('performans').value = newValue ? 'true' : 'false'; 
    },
    updateModelHedefleme(newValue: boolean) {
      this.modelHedefleme = newValue;
      const hedeflemeCookie = useCookie('hedefleme');
      hedeflemeCookie.value = String(newValue); // Çerezi yazma
    },
    updateModelIslevsel(newValue: boolean) {
      this.modelIslevsel = newValue;
      const islevselCookie = useCookie('islevsel');
      islevselCookie.value = String(newValue); // Çerezi yazma
    },

    // Çerezleri silme
    async removePerformanceCookies() {
      useCookie('__hssrc').value = '';
      useCookie('_ga').value = '';
      useCookie('_ga_C79XLZQGF2').value = '';
      useCookie('_ga_5M9XBNXME7').value = '';
      useCookie('_ga_VS6HELBN5J').value = '';
      useCookie('_ga_Z497X63GK8').value = '';
      useCookie('__hstc').value = '';
      useCookie('_hjSession_5121353').value = '';
      useCookie('_hjSessionUser_5121353').value = '';
    },

    async removeIslevselCookies() {
      useCookie('hubspotutk').value = '';
      useCookie('_hjMinimizedPolls').value = '';
      useCookie('_fw_crm_v').value = '';
      useCookie('SEARCH_SAMESITE').value = '';
    },

    async removeHedeflemeCookies() {
      const cookiesToRemove = [
        'bcookie',
        'lidc',
        '_gcl_au',
        '_fbp',
        'NID',
        'SID',
        'SSID',
        'SAPISID',
        'APISID',
        'HSID',
        '__Secure-1PAPISID',
        '__Secure-3PAPISID',
        '__Secure-1PSID',
        '__Secure-3PSID',
        '__Secure-3PSIDCC',
        '__Secure-1PSIDCC',
        'SIDCC',
        'AEC',
        '__Secure-1PSIDTS',
        '__Secure-3PSIDTS',
      ];
      cookiesToRemove.forEach(cookie => {
        useCookie(cookie).value = '';
      });
    },

    // Çerezleri güncelleme
    async setCookies() {
      if (!this.modelPerformans) this.removePerformanceCookies();
      if (!this.modelHedefleme) this.removeHedeflemeCookies();
      if (!this.modelIslevsel) this.removeIslevselCookies();
    },

    // Çerezlere 'true' olarak değer atama
    acceptCookies() {
      useCookie('cookiesAccepted').value = 'true';
      useCookie('performans').value = 'true';
      useCookie('hedefleme').value = 'true';
      useCookie('islevsel').value = 'true';
    },

    // Çerezlere 'false' olarak değer atama
    declineCookies() {
      useCookie('cookiesAccepted').value = 'false';
      useCookie('performans').value = 'false';
      useCookie('hedefleme').value = 'false';
      useCookie('islevsel').value = 'false';
    },

    // Çerez değerlerini güncelleme
    updatedAppVueCookie() {
      // Çerez değerlerini doğru bir şekilde okuyup boolean'a çeviriyoruz
      // const hedefleme = useCookie('hedefleme').value === 'true';
      // const performans = useCookie('performans').value === 'true';
      // const islevsel = useCookie('islevsel').value === 'true';
    
      // // Değerleri güncelliyoruz
      // this.updateModelHedefleme(hedefleme);
      // this.updateModelPerformans(performans);
      // this.updateModelIslevsel(islevsel);
    
      // Çerezleri güncelliyoruz
      this.setCookies();
    }
  },
});
